import React from "react";
import "./achievementComponent.css";
import OptimizedSlideshow from '../projects/OptimizedSlideshow';

import image1 from "./images/workshop1.jpeg";
import image2 from "./images/workshop2.jpeg";
import image3 from "./images/workshop3.jpeg" ;
import image4 from "./images/workshop4.jpeg" ;
import image5 from "./images/workshop5.jpeg";



const Workshop = () => {
    const images = [image1,image5,image2, image3, image4];

    return (
    <section className="RedRadio section" id="RedRadio">
        <h2 className="section__title">Linear Regression Workshop</h2>
        <span className="section__subtitle">Teacher</span>
        <OptimizedSlideshow mediaItems={images} />
        
        <div className="about__container container grid">
           

            <div className="text__container1">
                <h3 className="title">Description:</h3>
                <div className="achievement__content">
                    <p className='redRadio__text'>
                        🎓 Hosted a <strong>3-hour workshop on Linear Regression</strong> as part of <strong>DeepFlow's AI education initiative</strong>, aimed at empowering the next generation of data scientists and AI enthusiasts. 🌟
                    </p>
                    <p className='redRadio__text'>
                        💡 Covered key topics including:
                    </p>
                    <ul className="achievement__list">
                        <li className='redRadio__text'>✅ Foundations and real-world applications of AI</li>
                        <li className='redRadio__text'>✅ Data preprocessing and feature encoding</li>
                        <li className='redRadio__text'>✅ Mathematical foundations of Linear Regression</li>
                        <li className='redRadio__text'>✅ Hands-on implementation for real-world problem-solving</li>
                    </ul>
                    <p className='redRadio__text'>
                        🚀 Inspired participants to explore the power of AI through interactive learning and practical exercises — continuing DeepFlow's mission of <strong>AI for All</strong> 💪✨
                    </p>
                </div>
            </div>
        </div>
    </section>
    );
};

export default Workshop;
